export enum tableType  {
    USERS  = "users",
    CENTERS = "centers",
   
}



export enum tableAction {
    CREATE_ROW = 'createRow',
    UPDATE_ROW = 'updateRow',
    DELETE_ROW = 'deleteRow',
    VIEW_ROW = 'viewRow'
}


/**
 * 
 */
export enum PATIENT_FILTER {
    ALL_PATIENTS = 'all_patients',
    CENTER_PATIENTS = 'center_patients',
    DOCTOR_PATIENTS = 'doctor_patients',
    CURRENT_BOX = 'current_box'

}

export enum LAST_UPDATE_FILTER {
    CONSULTATION = 'consultation',
    PATIENT_FILE = 'patient_file'

}